export const loginMutation = /* GraphQL */ `
  mutation login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      username
      role
    }
  }
`;
